export default "__VITE_ASSET__1IiUMAb3__"